import React, { useState } from 'react';
import "./forgetPassword.scss";

import { forgetPasswordWS } from './api/forgetPasswordApi';

import { t } from 'i18next'
import { Button, Form, Stack } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom';

import SnackBar from '../../components/snackbar/Snackbar';
import { gestioneSnackbar } from '../../utils/common';

const ForgetPassword = () => {
    const navigate = useNavigate();

    const [email, setEmail] = useState("");

    return (
        <div className='forget-password-container'>
            <div>
                <Stack className='stack-forget-password' gap={2}>
                    <div className="forget-password">
                        <div><h4>{t('forget_password.title')}</h4></div>
                        <div><p>{t('forget_password.subtitle')}</p></div>
                    </div>
                    <Form>
                        <Form.Group className="mb-3" controlId="formPlaintextEmail">
                            <Form.Control className="input-forget-password" type="email" placeholder={t("common.email")}
                                value={email} onChange={(e) => setEmail(e.target.value)} />
                        </Form.Group>
                    </Form>
                    <Button className='button-forget-password' variant="light" size="md"
                        onClick={() => {
                            forgetPasswordWS({ email }).then((res) => {
                                gestioneSnackbar(true, res.message, "error");
                                navigate("../login");
                            }).catch((err) => {
                                gestioneSnackbar(true, err.message, "error");
                            });
                        }} active>
                        {t("common.send")}
                    </Button>
                    <Link to="../login" className='secondary-text-link'>{t("common.cancel")}</Link>
                </Stack>
            </div>
            <SnackBar />
        </div >
    )
}

export default ForgetPassword
